import React from "react";
import type { ShopifyApiVersion } from "state-trees/src/connections/shopify/ShopifyApiVersion";
import { eachShopifyModelMetadataForVersion, shopifyModelSpecOptions } from "state-trees/src/connections/shopify/ShopifyModelMetadata";
import { isShopifySyncOnlyField } from "state-trees/src/connections/ShopifyFieldConfig";
import type { ConnectionModelSpec } from "state-trees/src/connections/utils";
import { TD, TH, TR, Table } from "web/src/components/markdown/Table";
import { InlineCode } from "../../markdown-components";

export const ShopifySyncOnlyTable = (props: { apiVersion: ShopifyApiVersion; frameworkVersionConstraint: string }) => {
  const apiVersion = props.apiVersion;
  const frameworkVersionConstraint = props.frameworkVersionConstraint;
  const modelSpecOptions = shopifyModelSpecOptions(apiVersion, frameworkVersionConstraint);
  const models: ConnectionModelSpec[] = [];

  for (const meta of eachShopifyModelMetadataForVersion(apiVersion, frameworkVersionConstraint)) {
    const modelHasWebhooks = meta.webhooks && Object.keys(meta.webhooks).length > 0;
    const modelInheritsWebhooks = meta.inheritWebhooks;
    if (modelHasWebhooks || modelInheritsWebhooks) {
      const spec = meta.spec(modelSpecOptions);
      if (spec?.fields.some((f) => isShopifySyncOnlyField({ modelKey: spec.key, apiVersion, frameworkVersionConstraint, fieldSpec: f }))) {
        models.push(spec);
      }
    }
  }

  return (
    <Table>
      <TR>
        <TH>Model Name</TH>
        <TH>Fields</TH>
      </TR>
      {models.map((spec) => (
        <TR key={spec.key}>
          <TD>{spec.name}</TD>
          <TD>
            {spec.fields
              .filter((f) => isShopifySyncOnlyField({ modelKey: spec.key, apiVersion, frameworkVersionConstraint, fieldSpec: f }))
              .map((f) => (
                <InlineCode key={f.name}>{f.name}</InlineCode>
              ))}
          </TD>
        </TR>
      ))}
    </Table>
  );
};
